export function resolveAllowedApiBase(candidate: string | null | undefined): string {
  const fallback = '/api';
  if (!candidate?.trim() || typeof window === 'undefined') return fallback;

  const normalized = candidate.trim().replace(/\/$/, '');
  const projectId = window.VITE_ENV?.VITE_FIREBASE_PROJECT_ID || 'in3devoneuralai';

  try {
    const parsed = new URL(normalized, window.location.origin);
    const pageHost = new URL(window.location.origin).hostname;
    const isLocalPage = pageHost === 'localhost' || pageHost === '127.0.0.1';
    const isLoopback = parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';
    const isProjectHosting = parsed.origin === `https://${projectId}.web.app` ||
      parsed.origin === `https://${projectId}.firebaseapp.com`;
    const isProjectFunctions = parsed.origin === `https://us-central1-${projectId}.cloudfunctions.net`;
    const allowedOrigin = parsed.origin === window.location.origin || isProjectHosting || isProjectFunctions ||
      (isLocalPage && isLoopback && parsed.protocol === 'http:');

    if (parsed.pathname === '/api' && !parsed.search && !parsed.hash && allowedOrigin) return normalized;
  } catch {
    return fallback;
  }

  console.warn('[apiBase] Rejected untrusted apiBase:', normalized);
  return fallback;
}
